import Spec from './ComposedSpec';
import SpecQuery from './SpecQuery.graphql';

Spec.query = SpecQuery;

export default Spec;
